import React, { useState } from "react";

function DragAndDropFileUploadRow({
  colSpan = 3,
  selectedFile,
  setSelectedFile,
  handleUpload,
  isAudio = false,
}) {
  const [dragActive, setDragActive] = useState(false);
  const [fileTitle, setFileTitle] = useState("");

  // Reuse your existing logic:
  const getBaseName = (filePath) => {
    return filePath.replace(/\.[^/.]+$/, "");
  };

  const handleFileSelect = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (isAudio && !file.type.startsWith("audio/")) {
      alert("Please select a valid audio file.");
      return;
    }
    setSelectedFile(file);
    setFileTitle(getBaseName(file.name));
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (e.dataTransfer?.files?.length > 0) {
      const file = e.dataTransfer.files[0];
      if (isAudio && !file.type.startsWith("audio/")) {
        alert("Please drop a valid audio file");
        return;
      }
      setSelectedFile(file);
      setFileTitle(getBaseName(file.name));
      e.dataTransfer.clearData();
    }
  };

  const onUploadClick = () => {
    if (!selectedFile) return;
    handleUpload(selectedFile, fileTitle);
  };

  const acceptType = isAudio ? "audio/*" : "*";

  return (
    <tr className="hover:bg-gray-50">
      {/* Span all columns so it looks like one wide row */}
      <td colSpan={colSpan} className="px-6 py-3">
        {/* The “drop” area */}
        <div
          className={`border-2 border-dashed p-6 text-center ${
            dragActive ? "border-blue-500" : "border-gray-300"
          }`}
          style={{ cursor: "pointer" }}
          onDragOver={handleDragOver}
          onDragEnter={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          {/* Hidden file input */}
          <input
            type="file"
            accept={acceptType}
            onChange={handleFileSelect}
            style={{ display: "none" }}
            id="file-input"
          />
          {/* Label that triggers file input */}
          <label htmlFor="file-input" className="cursor-pointer">
            <i className="bi bi-cloud-upload fs-1"></i>
            <p className="mt-2">
              {dragActive
                ? isAudio
                  ? "Drop your audio file here"
                  : "Drop your file here"
                : isAudio
                ? "Click or drag and drop your audio file here"
                : "Click or drag and drop files to upload"}
            </p>
          </label>
        </div>

        {/* File title input (only visible if we have a selected file) */}
        {selectedFile && (
          <div className="mt-3">
            <label className="form-label">File Title</label>
            <input
              type="text"
              className="form-control"
              value={fileTitle}
              onChange={(e) => setFileTitle(e.target.value)}
            />
          </div>
        )}

        {/* Upload button */}
        <button
          className="mt-3 px-4 py-2 bg-blue-600 text-white rounded"
          onClick={onUploadClick}
          disabled={!selectedFile}
          type="button"
        >
          {selectedFile ? `Upload "${fileTitle}"` : "No File Selected"}
        </button>
      </td>
    </tr>
  );
}

export default DragAndDropFileUploadRow;
